import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getProvincias, deleteProvincia } from "../../../../api/provincia";
import {
  Button,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import { getCountries } from "../../../../api/country";
import { shallowEqual, useSelector } from "react-redux";
import FiltersCard from "../../../components/filters/Filter";

function getEmptyListCountries() {
  return [
    {
      _id: "",
      name: ""
    }
  ]
}


export default function ProvincePage() {
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [data, setData] = useState([])
  const [provinceId, setProvinceId] = useState(null);
  const [countries, setCountries] = useState(getEmptyListCountries());

  // const [collapsed, setCollapsed] = useState(true);
  // const [filteredData, setFilteredData] = useState([]);


  function buttonFormatter(cell) {
    const elem = data.find((item) => item.id === cell);
    return (
      <>
        <Tooltip title="Editar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-province/" + elem.id)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {user?.isAdmin && (
          <>
            <Tooltip title="Borrar">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setProvinceId(cell);
                  setOpenConfirmDialog(true);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }


  const columns = [
    { dataField: "name", text: "Nombre", sort: true },
    { dataField: "pais", text: "País", sort: true },
    {
      dataField: "id",
      text: "",
      formatter: buttonFormatter,
      headerStyle: { width: '150px' }
    },
  ];


  useEffect(() => {
    Promise.all([getCountries(), getProvincias()])
      .then(([countriesRes, provinciasRes]) => {
        setCountries(countriesRes.data);
        const result = provinciasRes.data.map(province => ({
          name: province.fullName,
          pais: countriesRes.data.find(item => item._id === province.pais)?.name,
          createdAt: province.createdAt,
          id: province._id
        }));
        setData(result);
        setRefresh(false);
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Error fetching countries or provinces.",
        });
      });
  }, [refresh]);


  return (
    <>
      <Card>
        <CardHeader title="Provincias">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary text-white"
              onClick={() => history.push("/edit-province")}
            >
              Añadir
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table data={data} columns={columns} />

          <ConfirmDialog
            title={"Seguro que quieres eliminar esta provincia?"}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteProvincia(provinceId)
                .then((res) => {
                  alertSuccess({
                    title: "Eliminado!",
                    customMessage: "Provincia eliminada correctamente.",
                  });
                  setRefresh(true);

                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "No se ha podido eliminar la provincia.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
